import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { toast } from 'sonner'
import i18next from 'i18next'

type Theme = 'light' | 'dark'

interface ThemeState {
  theme: Theme
  toggleTheme: () => void
  setTheme: (theme: Theme) => void
}

// Helper function to apply theme to document
const applyTheme = (theme: Theme) => {
  document.documentElement.classList.toggle('dark', theme === 'dark')
}

// Helper function to show theme change toast
//const showThemeToast = (theme: Theme) => {
//  toast(i18next.t(theme === 'dark' ? 'menu.darkMode' : 'menu.lightMode'), {
//    duration: 1500,
//  })
//}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'light',
      toggleTheme: () =>
        set((state) => {
          const newTheme = state.theme === 'light' ? 'dark' : 'light'
          applyTheme(newTheme)
        //  showThemeToast(newTheme)
          return { theme: newTheme }
        }),
      setTheme: (theme) => {
        applyTheme(theme)
        //showThemeToast(theme)
        set({ theme })
      },
    }),
    {
      name: 'theme-storage',
      onRehydrateStorage: (state) => {
        // Apply theme when store is rehydrated from storage
        return (state) => {
          if (state) {
            applyTheme(state.theme)
          }
        }
      },
    }
  )
)
